@use "app/styles/sticky" as sticky;
@use "app/styles/colors" as colors;

$fixed-controls-height: 5.5rem;

.menu {
  position: sticky;
  flex-direction: column;
  width: 12rem;
  top: 0;
  height: 100dvh;
  display: none;
}

:global(.show-mobile-menu #site-menu) {
  display: block;
  position: static;
  visibility: hidden;
  will-change: auto;

  > * {
    visibility: visible;
    z-index: 2;
  }

  .nav {
    scrollbar-width: thin;
  }
}

.nav {
  flex-grow: 1;
  font-size: 0.9rem;
  overflow-y: auto;
  overscroll-behavior-y: contain;
  scrollbar-width: none;

  > ul {
    padding: 2.5rem 0;
    :global(#page-menu) & > li {
      @include colors.section("yellow");

      $i: 1;
      @each $color in "red", "blue", "green" {
        &:nth-of-type(4n + #{$i}) {
          @include colors.section($color);
        }
        $i: $i + 1;
      }
    }
  }

  ul {
    display: flex;
    flex-direction: column;
    list-style-type: none;
  }

  li {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  code {
    color: inherit;
    background-color: transparent;
    padding: 0;

    &::before,
    &::after {
      content: none;
    }
  }

  a {
    color: var(--color-foreground);
    font-weight: 400;
    line-height: 1.6;
    text-decoration-line: none;
    text-decoration-color: currentColor;

    &:hover {
      @media (pointer: fine) {
        text-decoration-line: underline;
      }
    }

    &[aria-current="true"] {
      padding-left: 0.5rem;
      border-left: 2px solid var(--color-red-light);
    }

    :global(#page-menu) &[aria-current="step"] {
      color: var(--section-color);
    }
  }

  strong {
    font-weight: 500;
    text-transform: uppercase;
    color: var(--color-red);
    line-height: 1.6;
    background: linear-gradient(
      to bottom,
      var(--color-red),
      color-mix(in srgb, var(--color-red-alt), var(--color-red))
    );
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }
}

#siteNav {
  :global(.show-mobile-menu) & {
    position: fixed;
    display: block;
    left: 0;
    right: 0;
    top: calc(sticky.$size + sticky.$pageLinksHeight);
    bottom: $fixed-controls-height;
    padding: 1rem var(--root-gap);
    background-color: var(--color-background);
    transform: none !important;
    font-size: 1rem;

    & > ul {
      padding-top: 0;
      transform: none !important;
      width: 100%;

      > li {
        border-bottom: 1px solid var(--color-red-dim);
        padding-bottom: 1rem;

        &:last-of-type {
          border-bottom: 0;
        }
      }

      ul {
        flex-direction: row;
        flex-wrap: wrap;
        column-gap: 0.5rem;

        li {
          width: auto;
          padding: 0.375rem 0;

          &:not(:last-of-type)::after {
            content: "·";
            color: var(--color-gray);
            margin-left: 0.5rem;
          }
        }
      }
    }

    a {
      border: none;
      padding: 0;

      &[aria-current="true"] {
        color: var(--color-red);
        font-weight: 500;
      }
    }

    strong {
      display: block;
      font-size: 1.25rem;
      margin: 0.75rem 0 0.25rem;
    }
  }
  > ul {
    gap: 1rem;
  }
}

@include sticky.supported {
  .menu {
    margin-top: calc(-1 * sticky.$size);
  }

  .nav {
    transform-origin: top left;
    transform: translateY(sticky.$size) scaleY(sticky.$scale);
    will-change: transform;
    @include sticky.animate(scale-nav);

    & > ul {
      transform-origin: top left;
      transform: scaleY(calc(1 / sticky.$scale));
      will-change: transform;
      @include sticky.animate(scale-nav);
    }
  }

  @keyframes scale-nav {
    to {
      transform: scaleY(1) translateY(0);
    }
  }
}

#controls {
  position: relative;
  display: flex;
  gap: 0.5rem;
  flex-direction: column;
  padding: 1.5rem 0;
  margin-top: auto;
  background-color: var(--color-background);
  &::before {
    content: "";
    pointer-events: none;
    position: absolute;
    top: -2rem;
    left: 0;
    width: 100%;
    height: 2rem;
    background: linear-gradient(to top, var(--color-background), transparent);
  }
  strong {
    color: var(--color-foreground);
    font-weight: 700;
  }

  :global(.show-mobile-menu) & {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    margin: 0;
    padding: 0 var(--root-gap);
    height: $fixed-controls-height;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    column-gap: 1.25rem;
    justify-content: center;
  }
}

.versionControl {
  select {
    @include colors.section("gray");
  }
}
